import { IPartnerOffice } from './../partner';

export enum IUserRole {
  Admin = 'Admin',
  Enroly = 'Enroly',
  UniAdmin = 'UniAdmin',
  Uni = 'Uni',
  UniSecure = 'UniSecure',
  UniLite = 'UniLite',
  Agent = 'Agent',
  AgencyAdmin = 'AgencyAdmin',
  // Partner = Service Provider
  Partner = 'Partner',
  ImmigrationProvider = 'ImmigrationProvider',
  Student = 'Student',
  Applicant = 'Applicant',
  TempApplicant = 'TempApplicant'
}

export enum UserStatus {
  // User was created
  NEW = 'NEW',
  // User has been confirmed
  CONFIRMED = 'CONFIRMED',
  // User password was reset
  PASSWORD_RESET = 'PASSWORD_RESET'
}

export enum PathwayAccess {
  Full = 'Full',
  Partial = 'Partial',
  None = 'None'
}

export enum MfaMethod {
  TOTP = 'totp',
  SMS = 'sms',
  EMAIL = 'email'
}

export enum UserErrorMessages {
  USER_WITH_EMAIL_ALREADY_EXISTS = 'User with this email already exists'
}

export interface IUser {
  p_key?: string;
  s_key?: string /* s_key is username */;
  userId?: string; // cognito.sub - used for applicants
  status: UserStatus;
  givenName: string;
  familyName: string;
  email: string;
  emailVerified?: boolean;
  userRole?: IUserRole | string /* empty userRole = user is a student */;
  intakeId?: string;
  studentNo?: string;
  terms?: boolean;
  marketing?: boolean;
  university?: string;
  agency?: string;
  agencyOffice?: string;
  regionAccessId?: string;
  OTP?: string;
  pathway?: string;
  pathwayAccess?: PathwayAccess | string;
  partner?: string;
  partnerOffice?: string;
  partnerOfficeDetails?: IPartnerOffice /* not stored in DB, frontend-only field */;
  immigrationProvider?: string;
  agencyName?: string /* not stored in DB, frontend-only field */;
  agencyOfficeName?: string /* not stored in DB, frontend-only field */;
  streakBoxUni?: string;
  streakBoxAgent?: string;
  pathwayMigrationPending?: boolean;
  mfaEnabled?: boolean;
  phoneNumber?: string;
  beta?: boolean;
  insightsAccess?: boolean;
  refreshToken?: string;
  verifiedApplicant?: boolean;
  hasLoggedIn?: boolean; // used for applicant login flow: three state flag: undefined(initially), false (after user management login for auth tokens), true (on client auth)
}

export type IUserLogin = {
  login_time: number;
} & {
  [key: string]: string;
};

export interface IUserLogins extends IUser {
  logins?: IUserLogin[];
}
